/**
 * Команды серверного уровня для управления view.
 */
var ViewServerCommand;
(function (ViewServerCommand) {
    /** Закрыть view */
    ViewServerCommand["close"] = "close";
    /** Перезагрузить view */
    ViewServerCommand["reload"] = "reload";
    /** Обновить view (refresh) */
    ViewServerCommand["refresh"] = "refresh";
    /** Перезагрузить элемент по ключу */
    ViewServerCommand["reloadElement"] = "reloadElement";
    /** Установка обязательных значений */
    ViewServerCommand["setRequiredValues"] = "setRequiredValues";
    /** Перезапись html элемента или view */
    ViewServerCommand["reloadResult"] = "reloadResult";
    /** Подтверждение что форма была сохранена в процессе работы серверной команды */
    ViewServerCommand["saved"] = "saved";
    /** Установить режим формы */
    ViewServerCommand["setFormMode"] = "setFormMode";
})(ViewServerCommand || (ViewServerCommand = {}));

export { ViewServerCommand };
